var ListConfs = Class.extend({
    actions : ['actionDelete','actionDeleteAll','actionEdit','actionView','actionInsert'],
    extra_actions : {},
    fields : [],
    detail_fields: {},
    fields_type: {
        id :            {type:'input','inputType': 'hidden'},
        created_at:     {type:'input','inputType': 'hidden'},
        updated_at:     {type:'input','inputType': 'hidden'},
        deleted_at:     {type:'input','inputType': 'hidden'},
        created_by:     {type:'input','inputType': 'hidden'},
        updated_by:     {type:'input','inputType': 'hidden'},
        descrizione_it: {type:'input','inputType': 'hidden'},
        descrizione_en: {type:'input','inputType': 'hidden'},
        descrizione_de: {type:'input','inputType': 'hidden'},
        descrizione	:   {type:'input','inputType': 'hidden'},
        tags:           {type:'input','inputType': 'hidden'},
        titolo_en:      {type:'input','inputType': 'hidden'},
        titolo_de:      {type:'input','inputType': 'hidden'},
        attivo:         {type: 'swap','mode': 'edit'},
        in_evidenza:    {type: 'swap','mode': 'edit'},
        activated:      {type: 'swap','mode': 'edit'},
        verified:       {type: 'swap','mode': 'edit'},
        errors :        {type:'input','inputType': 'hidden'},
        oauth_type :    {type:'input','inputType': 'hidden'},
        oauth_data :    {type:'input','inputType': 'hidden'},
        oauth_id :      {type:'input','inputType': 'hidden'},
        token:          {type:'input','inputType': 'hidden'},
        icon:           {type: 'faicon'},
        indirizzi:      {type:'input','inputType': 'hidden'},
        telefoni:       {type:'input','inputType': 'hidden'},
        emails:         {type:'input','inputType': 'hidden'},
        fotos:          {type: 'hasmany_upload',uploadType: 'foto',limit:1},
        attachments:    {type: 'hasmany_upload',uploadType: 'attachment',limit:1},
        data:           {type: 'date'}
    }
});

var EditConfs = Class.extend({
    actions : ['actionSave','actionBack','actionSaveBack'],
    extra_actions : {},
    labels: 'left',
    fields: [],
    fields_type: {
        id: {type:'input','inputType': 'hidden'},
        created_at: {type:'input','inputType': 'hidden'},
        updated_at: {type:'input','inputType': 'hidden'},
        deleted_at: {type:'input','inputType': 'hidden'},
        created_by: {type:'input','inputType': 'hidden'},
        updated_by: {type:'input','inputType': 'hidden'},

        newsletter_registered:  {type: 'choice', choiceType: 'radio'},
        in_evidenza:            {type: 'choice', choiceType: 'radio'},
        attivo:                 {type: 'choice', choiceType: 'radio'},
        riservato:              {type: 'choice', choiceType: 'radio'},
        activated:              {type: 'choice', choiceType: 'radio'},

        descrizione_it: {type: 'texthtml'},
        descrizione_en: {type: 'texthtml'},
        descrizione_de: {type: 'texthtml'},
        descrizione: {type: 'texthtml'},
        body: {type: 'texthtml'},
        note: {type: 'texthtml'},
        fotos: {type: 'hasmany_upload', uploadType: 'foto', 'label': 'no'},
        attachments: {type: 'hasmany_upload', uploadType: 'attachment', 'label': 'no'},
        //videos: {'type': 'video', 'label' : 'no'},
        data: {type: 'date', dateType: 'picker'},
        data_formatted: {type:'input','inputType': 'hidden'},
        status: {type:'input','inputType': 'hidden'},

        newsletter: {type:'input','inputType': 'hidden'},
        token: {type:'input','inputType': 'hidden'},
        captcha: {type: 'captcha'},
        icon: {type: 'faicon'},
        indirizzi: {
            type: 'hasmany',
            label: 'no'
        },
        telefoni: {
            type: 'hasmany',
            label: 'no'
        },
        emails: {
            type: 'hasmany',
            label: 'no'
        },
        gpslat: {
            type: 'decimal',
            decimal_digits: 5,
            int_digits: 2
            //symbol : "&euro;"
        },
        gpslon: {
            type: 'decimal',
            decimal_digits: 5,
            int_digits: 2
            //symbol : ""
        }
    },
    dependencies : {}
});

var InsertConfs = EditConfs.extend({});

var SearchConfs = Class.extend({
    actions : ['actionSearch','actionReset'],
    extra_actions : {},
    fields:[],
    fields_type : {},
    /*
    order: {},
    layout_columns: 3,
    control_type: {},
    layouts : {},
    lang_fields : []
    */
});

var ViewConfs = Class.extend({
    labels: 'left',
    actions : [],
    extra_actions : {},
    fields : [],
    fields_type: {
        attivo: {type: 'swap'},
        fotos : {type: 'hasmany_upload', uploadType: 'foto'},
        attachments: {type: 'hasmany_upload', uploadType: 'attachment'},
        id: {type:'input','inputType': 'hidden'},
        created_at: {type:'input','inputType': 'hidden'},
        updated_at: {type:'input','inputType': 'hidden'},
        deleted_at: {type:'input','inputType': 'hidden'},
        created_by: {type:'input','inputType': 'hidden'},
        updated_by: {type:'input','inputType': 'hidden'}
    }/*,
    layouts : {},
    lang_fields : []
    */
});

var CsvConfs = Class.extend({
    init : function () {

    },
    actions : [],
    upload_actions : [],//['actionRecuperaCsv'],
    load_actions : ['actionAddCsv','actionCsvCancel'],
    save_actions : ['actionSaveCsv','actionCsvCancel'],
    iszip : false,
    labels : 'left',
    fields : [],
    fields_type : {},
    load_fields : [],
    load_fields_type : {},
    save_fields : [],
    save_fields_type : {}
});

var CsvdataConfs = ListConfs.extend({
    init : function () {
        //this._super();
    },
    actions:['actionCsvShowAll','actionCsvShowError','actionCsvRevalidate'],
    error_type : {

        GTComReg : {
            readonly : true
        }
    }
});

var TreeConfs = Class.extend({

    child  : {}

});

var CalendarConfs = Class.extend({
    data_inizio : 'data',
    fields : [],
    dayClick : function(date, jsEvent, view) {
        // funzione chiamata al click del giorno vuoto
    },
    eventClick : function (calEvent, jsEvent, view) {
        // funzione chiamata al click sull'evento
    },
    viewRender : function (view,element) {},
    eventAfterAllRender : function (view) {}
});
